<template>
  <section
    :class="currentReviewsCount ? brandClasses.reviewsListContainer : 'pt-4'"
    data-test-id="customer-reviews"
  >
    <div :class="brandClasses.reviewsItemsContainer">
      <template v-if="reviewsPending">
        <product-reviews-skeleton v-for="key in pageSize" :key />
      </template>
      <product-reviews-item
        v-else
        v-for="review in reviews"
        :key="review.reviewId"
        :product-id="productId"
        :review="review"
        :search-term="searchTerm"
      />
    </div>
    <div class="f-col center md:flex-row md:between" :class="{ 'gap-1': pagesCount > 1 }">
      <div class="f-col center gap-2 md:flex-row md:gap-4">
        <p
          :class="currentReviewsCount ? 'c-grey-20' : 'text-base'"
          data-test-id="display-reviews"
          role="status"
        >
          {{ currentReviewsDisplayed }}
        </p>
        <base-button
          v-if="currentReviewsCount"
          class="underlined"
          data-test-id="reviews-back-to-top"
          @click="$emit('back-to-top')"
        >
          {{ $t.backToTop }}
        </base-button>
      </div>
      <div class="flex">
        <base-button
          v-if="currentPageNumber > 1"
          class="underlined"
          @click="$emit('previous')"
        >
          {{ $t.previous }}
        </base-button>
        <span v-if="currentPageNumber > 1 && currentPageNumber < pagesCount" class="mx-2">|</span>
        <base-button
          v-if="pagesCount && currentPageNumber < pagesCount"
          class="underlined"
          data-test-id="reviews-next"
          @click="$emit('next')"
        >
          {{ $t.next }}
        </base-button>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { ProductReviewsReview } from '#root/api/clients/product/data-contracts'
import type { ButtonVariant } from '#types/components/vf/button'

defineProps<{
  currentPageNumber: number
  currentReviewsCount: number
  currentReviewsDisplayed: string
  pageSize: number
  pagesCount: number
  productId: string
  reviews: ProductReviewsReview[]
  reviewsCount: number
  reviewsPending: boolean
  searchTerm?: string
  variant?: ButtonVariant
}>()

defineEmits<{
  'back-to-top': []
  'next': []
  'previous': []
}>()

const { brandClasses } = useAppConfig().pages.pdp
</script>
